import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HttpClientModule} from '@angular/common/http';
import {IconPacksManagerService} from '@og-lib/theme/services';
import {TranslateService, TranslateStore} from '@ngx-translate/core';
import {
  LocalizationModule,
  TranslationService,
} from '@og-lib/core/localization';
import {SystemStoreFacadeService} from '@og-lib/core/store';
import {EnvAdapterService} from '@og-lib/core/store/adapters';
import {ApiService} from '@og-lib/core/api';
import {CoreModule} from '@og-lib/core/core.module';
import {APP_CONFIG} from '@og-lib/app-config';
import {environment} from '../environments/environment';
import {ThemeModule} from '@og-lib/theme/theme.module';
import {OverlayModule} from '@angular/cdk/overlay';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {GanttModule} from '@og-lib/components/index';
import {SelectModule} from '@og-lib/components/selector';

@NgModule({
  declarations: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    LocalizationModule,
    CoreModule,
    ThemeModule.forRoot('default'),
    OverlayModule,
    SelectModule,
    GanttModule,
    BrowserAnimationsModule,
  ],
  providers: [
    TranslationService,
    TranslateService,
    IconPacksManagerService,
    TranslateStore,
    SystemStoreFacadeService,
    EnvAdapterService,
    ApiService,
    {
      provide: APP_CONFIG,
      useValue: environment,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
